module.exports = __webpack_public_path__ + "static/media/ArrowBack.2c20c7a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ArrowBack.svg
// module id = 135
// module chunks = 0